import store from '@/store'
import { ShopUpdateZFBState } from '@/apis/shop'
import { QueryAdcInfo } from '@/apis/administrative'
const enumsData = store.state.enumsStore.enumsData
const {ZfbStoreState} = enumsData
export default {
  name: 'DetailDrawer',
  components: {  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    app: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      info: {},
      ZfbStoreState,
      activeLoading: false,
      btnDisabled: false,
      btnText: '刷新状态',
      intervalNumber: undefined,
      addressInfo: "",
      stateList:{
        "99": "已完结",
        "-1": "失败",
        "031":"已提交审核"
      }
    }
  },
  watch: {
    app: function(data) {
      if (data && this.visible) {
        console.log(data)
        this.info = { ...data }
        if (data.zfbStoreShowVO && data.zfbStoreShowVO.zfbStoreInfo){
          this.getAdcInfo(data.zfbStoreShowVO.zfbStoreInfo.adcId)
        }
      }
    }
  },
  created() {},
  methods: {
    queryStateName(state){
      return this.stateList[state] || ""
    },
    handlerReLoad(){
      let _this = this
      if (!_this.intervalNumber){
        ShopUpdateZFBState(_this.info.id).then(res=>{
          _this.info.zfbStoreShowVO = {...res.data}
          _this.subSeconds()
        })
      }
    },
    getAdcInfo(id){
      QueryAdcInfo({id}).then(res=>{
        console.log(res)
        let data = res.data
        this.addressInfo = data.provinceName + data.cityName + data.districtName
      })
    },
    subSeconds(){
      let _this = this
      _this.btnDisabled = true
      let countdown = 10; // 倒计时总秒数
      const intervalId = setInterval(() => {
        _this.btnText = `${countdown} S后可用`
        countdown--;
        if (countdown < 0) {
          clearInterval(intervalId); // 当倒计时结束时停止倒计时
          _this.btnDisabled = false
          _this.btnText = '刷新状态'
        }
      }, 1000);
    },
    onClose() {
      setTimeout(()=>{
        this.info = {}
      },300)
      this.$emit('close')
    }
  }
}
